import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ThemeService } from '@app/shared/services/theme.service';

@Component({
  selector: 'app-evolve-india',
  templateUrl: './evolve-india.component.html',
  styleUrl: './evolve-india.component.scss'
})
export class EvolveIndiaComponent implements OnInit{

  @ViewChild('speakerModal') speakerModal!: ElementRef;
  selectedSpeaker: any;
  currentTheme: string;
  defaultProfileImage = 'assets/images/thumb/no-thumb.jpeg';
  speakerInfo = [
    {
      name: 'Sunny Gupta',
      job_title: 'Engineering Leader, Atlassian',
      company: '',
      thumbs: 'assets/images/thumb/sunny.jpg',
      description: 'Sunny Gupta is an accomplished Engineering Manager with Atlassian, one of the leading software companies in the world. His passion for coding started at the young age of 12, and since then, he has spent over a decade in the industry, working across various verticals such as eCommerce, SaaS, Fashion-Tech, Med-Tech, and Media, among others.',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/sunnykgupta/',
      mail: '',
      sort: 1
    },
    {
      name: 'Jikku Jose',
      job_title: 'Ruby developer running a small startup by the name Qucentis in Kerala Startup Mission',
      company: '',
      thumbs: 'assets/images/thumb/Jikku-Jose.jpg',
      description: 'Jikku Jose is a Ruby developer running a small startup by the name Qucentis in Kerala Startup Mission. Now working on building a framework for rapid prototyping of apps using Ruby.',
      facebook: 'https://www.facebook.com/JikkuJose',
      twitter: 'https://twitter.com/jikkujose?lang=en',
      linkedin: 'https://www.linkedin.com/in/jikkujose/',
      mail: '',
      sort: 2
    },
    {
      name: 'Anish Aravind',
      job_title: 'Co-Founder & Principal Consultant, SS Consulting',
      company: '',
      thumbs: 'assets/images/thumb/anish-aravind.jpg',
      description: 'Mr. Anish Aravind is a renowned human resource professional with over 16 years of experience in the manufacturing, FMCG, ITES, and IT industry segments. Mr. Aravind is also a seasoned OD and HR consultant with over 8 years of experience in the field. Mr. Aravind is currently the co-founder and principal consultant at SS Consulting and has served as the Secretary of the National Institute of Personnel Management from 2016-2021. He was recently recognized as one of the top 20 HR Influencers in 2023 by ET\'s ETHR World.',
      facebook: '',
      twitter: '',
      linkedin: 'https://www.linkedin.com/in/anisharavind/',
      mail: '',
      sort: 3
    },
    {
      name: 'Amrit Sanjeev',
      job_title: 'Staff Developer Advocate at Google and leads the developer advocacy initiatives for India.',
      company: '',
      thumbs: 'assets/images/thumb/amrit-sanjee.jpg',
      description: 'Amrit Sanjeev works as a Staff Developer Advocate at Google and leads the developer advocacy initiatives for India. He has over 15 years of industry experience and has worked in different areas like OS development, large scale backend systems design, software architecture and mobile research. Prior to Google he worked in companies like Inapp, IBM, Intuit & Philips Research. He was the first person from India to be accepted as a Google developer expert for Android and as an Intel innovator. He is the founder of Blrdroid - the largest open android developer community in India and a total petrol head .',
      facebook: 'https://www.facebook.com/amrit.sanjeev',
      twitter: 'https://twitter.com/amsanjeev',
      linkedin: 'https://www.linkedin.com/search/results/all/?keywords=Amrit%20Sanjeev&origin=GLOBAL_SEARCH_HEADER',
      mail: '',
      sort: 4
    },
    {
      name: 'Rajeev J Sebastian',
      job_title: 'CEO, Alokin Software',
      company: '',
      thumbs: 'assets/images/thumb/Rajeev-J-Sebastian.jpg',
      description: 'Rajeev has associated with many successful national and international projects during his 16 years in the industry, including One Rank One Pension, Kerala State Legislative Assembly Knowledge Base, DC Books, Rachana Malayalam Operating System, American Honda Bikes, Toyota Racing Development, AOL Movies and Music, etc. He is a follower and contributor to various open source projects such as KDE, Kubuntu, Pardus Linux, SCIM, Mootools, etc. He also played a leading role in the Malayalam Unicode encoding standards, and development of UIs and fonts for Malayalam. Currently the CEO of Alokin Software, he leads a team of Python and OOP developers and is deeply interested in Software Engineering, OOP, AI, philosophy and films.',
      facebook: 'https://www.facebook.com/rajeevjsebastian',
      twitter: 'https://twitter.com/rajeevjsv',
      linkedin: 'https://www.linkedin.com/in/rajeev-j-sebastian-290b972/',
      mail: 'rajeev.sebastian@alokin.in',
      sort: 5
    }
    
    
    
  ];

  constructor(public themeService: ThemeService) {
    this.themeService.themes.subscribe(theme => {
      this.currentTheme = theme;
    });
  }

  ngOnInit() {
    this.assignDefaultSortingNumbers(this.speakerInfo);
    this.sortSpeakersBySortingNumber();
  }
  showModal(speaker: any) {
    this.selectedSpeaker = speaker;
    this.speakerModal.nativeElement.open = !this.speakerModal.nativeElement.open;
  }
  onProfilePicError(event: any) {
    event.target.src = this.defaultProfileImage;
  }
  sortSpeakersBySortingNumber() {
    this.speakerInfo.sort((a, b) => a.sort - b.sort);
  }
  assignDefaultSortingNumbers(items: any[]) {
    items.forEach((item, index) => {
      if (!item.hasOwnProperty('sort')) {
        item.sort = index + 1; // Set a default sorting number based on the index
      }
    });
  }

}
